import { jsx as n, jsxs as v } from "react/jsx-runtime";
import * as c from "@radix-ui/react-tabs";
import { forwardRef as l, useContext as T, createContext as E } from "react";
import { c as r } from "./cn-DlLpp5ix.js";
import { F as u } from "./focus-BJKdC9pu.js";
const x = E({ variant: "pills", size: "md" }), b = l(
  function(s, a) {
    const { variant: t = "pills", size: e = "md", className: o, children: m, ...i } = s;
    return /* @__PURE__ */ n(x.Provider, { value: { variant: t, size: e }, children: /* @__PURE__ */ n(
      c.Root,
      {
        ref: a,
        className: r("flex flex-col", o),
        "data-variant": t,
        "data-size": e,
        ...i,
        children: m
      }
    ) });
  }
), L = "inline-flex items-center gap-1 p-1 rounded-lg bg-bg-elevated", S = "inline-flex items-center gap-3 border-b border-subtle", N = l(
  function(s, a) {
    const { variant: t } = T(x), { className: e, ...o } = s;
    return /* @__PURE__ */ n(
      c.List,
      {
        ref: a,
        className: r(t === "pills" ? L : S, e),
        ...o
      }
    );
  }
), _ = r(
  "inline-flex items-center gap-2 select-none whitespace-nowrap",
  "font-medium text-secondary",
  "transition-colors duration-fast ease-out",
  "data-[disabled]:cursor-not-allowed data-[disabled]:text-tertiary",
  u
), h = {
  sm: "h-7 px-2.5 rounded-md text-2xs",
  md: "h-8 px-3 rounded-md text-xs"
}, I = r(
  // active in pills: accent-dim bg, primary text.
  "data-[state=active]:bg-bg-surface data-[state=active]:text-primary data-[state=active]:shadow-xs",
  "hover:text-primary"
), C = {
  sm: "h-9 px-1 text-xs",
  md: "h-10 px-1 text-sm"
}, G = r(
  "relative -mb-px border-b-2 border-transparent",
  "data-[state=active]:border-accent data-[state=active]:text-primary",
  "hover:text-primary"
), y = l(
  function(s, a) {
    const { variant: t, size: e } = T(x), { className: o, children: m, count: i, icon: p, ...f } = s, R = t === "pills" ? h[e] : C[e], g = t === "pills" ? I : G;
    return /* @__PURE__ */ v(
      c.Trigger,
      {
        ref: a,
        className: r(_, R, g, o),
        ...f,
        children: [
          p !== void 0 && /* @__PURE__ */ n("span", { className: "inline-flex items-center", "aria-hidden": "true", children: p }),
          /* @__PURE__ */ n("span", { children: m }),
          i != null && /* @__PURE__ */ n("span", { className: "inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 text-2xs font-semibold rounded-sm bg-bg-base text-secondary", children: i })
        ]
      }
    );
  }
), w = l(
  function(s, a) {
    const { className: t, ...e } = s;
    return /* @__PURE__ */ n(
      c.Content,
      {
        ref: a,
        className: r("outline-none", u, t),
        ...e
      }
    );
  }
), U = Object.assign(b, {
  Root: b,
  List: N,
  Trigger: y,
  Content: w
});
export {
  U as T
};
//# sourceMappingURL=Tabs-p-MQ_Ra9.js.map
